<template>
  <div class="customStatistical" v-if="permisShow('客源统计')">
    <div class="total" style="padding-top:30px">
      <div class="tab">
        <div class="tab-item tab-active">客源分析</div>
        <div class="tab-item" @click="goto()">客源统计</div>
      </div>
      <div class="list">
        <div class="list-item">
          <div class="list-item-content1">
            <div class="list-item-title">总客源（人）</div>
            <div class="list-item-text">求购：{{YesterdayNumberData.buyNumber}} 求租：{{YesterdayNumberData.rentNumber}}</div>
          </div>
        </div>
        <div class="list-item">
          <div class="list-item-content2">
            <div class="list-item-title">昨日新增（人）</div>
            <div class="list-item-text">求购：{{YesterdayNumberData.buyAdd}} 求租：{{YesterdayNumberData.rentAdd}}</div>
          </div>
        </div>
        <div class="list-item">
          <div class="list-item-content3">
            <div class="list-item-title">昨日带看（人）</div>
            <div class="list-item-text">求购：{{YesterdayNumberData.buyLook}} 求租：{{YesterdayNumberData.rentLook}}</div>
          </div>
        </div>
        <div class="list-item">
          <div class="list-item-content4">
            <div class="list-item-title">昨日成交（人）</div>
            <div class="list-item-text">求购：{{YesterdayNumberData.buyDeal}} 求租：{{YesterdayNumberData.rentDeal}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="total2">
      <!-- 近半年新增成交对比 -->
      <div class="title">近半年新增成交对比</div>
      <div class="total2-content">
        <div class="total2-content-item">
          <div>
            <ve-histogram :data="HalfAddCusData" :settings="HalfAddCusDataset" :extend="extend"></ve-histogram>
          </div>
          <h3>新增客源</h3>
        </div>
        <div class="total2-content-item">
          <div>
            <ve-histogram :data="HalfYearStatistics" :settings="HalfYearStatisticsset" :extend="extend"></ve-histogram>
          </div>
          <h3>成交单数</h3>
        </div>
      </div>
    </div>

    <div class="total3">
      <!-- 近半年新增成交对比 -->
      <div class="total3-box">
        <div class="total3-box-title">客源销售分析</div>
        <div class="total3-box-item_time">
          <el-select v-model="data.year" placeholder="请选择" @change="getCusStatistics()">
            <el-option v-for="(item,index) in options" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <span class="total3-box-item_time_unit">年</span>
          <el-select v-model="data.month" placeholder="请选择" @change="getCusStatistics()">
            <el-option v-for="(item,index) in options1" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <span class="total3-box-item_time_unit">月</span>
        </div>
      </div>

      <div class="total3-content">
        <div class="total3-content-item">
          <div>
            <ve-pie :data="CusStatistics1"></ve-pie>
          </div>
          <h3>客户等级</h3>
        </div>
        <div class="total3-content-item">
          <div>
            <ve-pie :data="CusStatistics2"></ve-pie>
          </div>
          <h3>客户年龄</h3>
        </div>
        <div class="total3-content-item">
          <div>
            <ve-pie :data="CusStatistics3"></ve-pie>
          </div>
          <h3>来源渠道</h3>
        </div>
      </div>
    </div>

    <div class="total">
      <div class="bottom_title">
        <div class="title_text">业务数据分析</div>
        <div>
          <span class="report_form_title_tab" v-for="(item,index) in reportabData" :key="index" @click="reportTab(index)" :class="{report_form_title_tab_active:reportActive===index}">{{item}}</span>
        </div>
      </div>
      <ve-line :data="Statistics"></ve-line>
    </div>
  </div>
</template>

<script>
import {
  queryYesterdayNumber,
  queryHalfAddCus,
  queryHalfYearStatistics,
  queryCusStatistics,
  queryStatistics
} from "@/api/customStatistical";
export default {
  data() {
    let date = new Date();
    let permisList = JSON.parse(sessionStorage.getItem("permisList"));
    this.HalfAddCusDataset = {
      labelMap: {
        buyNumber: "求购",
        rentNumber: "求租",
        buyYearOnYear: "求购同比",
        rentYearOnYear: "求租同比",
        buyChainRatio: "求购环比",
        rentChainRatio: "求租环比"
      },
      showLine: [
        "buyYearOnYear",
        "rentYearOnYear",
        "buyChainRatio",
        "rentChainRatio"
      ]
    };
    this.extend = {
      tooltip: {
        formatter: function (params) { //自定义函数修改折线图给数据加单位
          // console.log(params)
          let str = '';//声明一个变量用来存储数据

          str += '<div>' + params[0].name + '</div>'; //显示日期的函数

          for (var i = 0; i < params.length; i++) { //图显示的数据较多时需要循环数据，这样才可以成功的给多条数据添加单位

            if (i === 2) {
              str += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + params[i].color + ';"></span>' + params[i].seriesName + '</span> : <span>' + (params[i].value) + '%' + '</br>';

            } else if (i === 3) {
              str += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + params[i].color + ';"></span>' + params[i].seriesName + '</span> : <span>' + (params[i].value) + '%' + '</br>';
            }
            else if (i === 4) {
              str += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + params[i].color + ';"></span>' + params[i].seriesName + '</span> : <span>' + (params[i].value) + '%' + '</br>';
            }
            else if (i === 5) {
              str += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + params[i].color + ';"></span>' + params[i].seriesName + '</span> : <span>' + (params[i].value) + '%' + '</br>';
            }
            else {
              str += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + params[i].color + ';"></span>' + params[i].seriesName + '</span> : <span>' + (params[i].value) + '</br>';

            }

          }
          return str;
        }
      }
    };
    this.HalfYearStatisticsset = {
      labelMap: {
        cusBuy: "求购",
        cusRent: "求租",
        buyYearOnYear: "求购同比",
        rentYearOnYear: "求租同比",
        buyChainRatio: "求购环比",
        rentChainRatio: "求租环比"
      },
      dimension: ["buyYearOnYear"],
      showLine: [
        "buyYearOnYear",
        "rentYearOnYear",
        "buyChainRatio",
        "rentChainRatio"
      ],
      dimension: ["date"]
    };
    return {
      permisList,
      data: {
        year: date.getFullYear(), //年
        month:
          date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1 //月
      },
      options: [
        {
          value: "2019",
          label: "2019"
        },
        {
          value: "2020",
          label: "2020"
        },
        {
          value: "2021",
          label: "2021"
        },
        {
          value: "2022",
          label: "2022"
        },
        {
          value: "2023",
          label: "2023"
        },
        {
          value: "2024",
          label: "2024"
        },
        {
          value: "2025",
          label: "2025"
        },
        {
          value: "2026",
          label: "2026"
        },
        {
          value: "2027",
          label: "2027"
        },
        {
          value: "2028",
          label: "2028"
        }
      ],
      options1: [
        {
          value: "",
          label: "不限"
        },
        {
          value: "01",
          label: "1"
        },
        {
          value: "02",
          label: "2"
        },
        {
          value: "03",
          label: "3"
        },
        {
          value: "04",
          label: "4"
        },
        {
          value: "05",
          label: "5"
        },
        {
          value: "06",
          label: "6"
        },
        {
          value: "07",
          label: "7"
        },
        {
          value: "08",
          label: "8"
        },
        {
          value: "09",
          label: "9"
        },
        {
          value: "10",
          label: "10"
        },
        {
          value: "11",
          label: "11"
        },
        {
          value: "12",
          label: "12"
        }
      ],
      monthOrWeek: "WEEK",
      reportabData: ["本周", "本月"],
      reportActive: 0,
      YesterdayNumberData: {}, //统计数据
      HalfAddCusData: {
        columns: [
          "yearAndMonth",
          "buyNumber",
          "rentNumber",
          "buyYearOnYear",
          "rentYearOnYear",
          "buyChainRatio",
          "rentChainRatio"
        ],
        rows: []
      }, //半年新增客源
      HalfYearStatistics: {
        columns: [
          "date",
          "cusBuy",
          "cusRent",
          "buyYearOnYear",
          "rentYearOnYear",
          "buyChainRatio",
          "rentChainRatio"
        ],
        rows: []
      }, //半年成交单数
      CusStatistics1: {
        columns: ["name", "amount"],
        rows: []
      }, //客源销售分析
      CusStatistics2: {
        columns: ["name", "amount"],
        rows: []
      }, //客源销售分析
      CusStatistics3: {
        columns: ["name", "amount"],
        rows: []
      }, //客源销售分析
      Statistics: {} //业务数据分析
    };
  },
  mounted() {
    this.getYesterdayNumber(); //查询统计
    this.getHalfAddCus(); //查询半年新增客源
    this.getHalfYearStatistics(); //查询成交单数
    this.getCusStatistics(); //查询客源销售分析
    this.getStatistics(); //查询业务数据分析
  },
  methods: {
    permisShow(data) {
      // 权限配置
      let result = this.permisList.indexOf(data);
      if (result >= 0) {
        return true;
      } else {
        return false;
      }
    },
    //跳转
    goto() {
      this.$router.push("customStatisticalList");
    },
    //查询统计
    getYesterdayNumber() {
      this.$post(queryYesterdayNumber).then(res => {
        if (res.success) {
          this.YesterdayNumberData = res.data;
        } else {
          this.$message({
            message: res.msg,
            type: "error",
            duration: 1000
          });
        }
      });
    },
    //查询半年新增客源
    getHalfAddCus() {
      this.$post(queryHalfAddCus).then(res => {
        if (res.success) {
          this.HalfAddCusData.rows = res.data;
        } else {
          this.$message({
            message: res.msg,
            type: "error",
            duration: 1000
          });
        }
      });
    },
    //查询半年成交单数
    getHalfYearStatistics() {
      let params = {
        houseOrCus: "lala"
      };
      this.$post(queryHalfYearStatistics, params).then(res => {
        if (res.success) {
          this.HalfYearStatistics.rows = res.data;
        } else {
          this.$message({
            message: res.msg,
            type: "error",
            duration: 1000
          });
        }
      });
    },
    //查询客源销售分析
    getCusStatistics() {
      let params = {
        year: this.data.year,
        month: this.data.month
      };
      this.$post(queryCusStatistics, params).then(res => {
        if (res.success) {
          this.CusStatistics1.rows = res.data.rows;
          this.CusStatistics2.rows = res.data.ageRows;
          this.CusStatistics3.rows = res.data.sourceRows;
        } else {
          this.$message({
            message: res.msg,
            type: "error",
            duration: 1000
          });
        }
      });
    },
    //业务数据分析切换
    reportTab(index) {
      this.reportActive = index;
      if (index == 0) {
        this.monthOrWeek = "WEEK";
      } else if (index == 1) {
        this.monthOrWeek = "MONTH";
      }
      this.getStatistics(); //查询业务数据分析
    },
    //查询业务数据分析
    getStatistics() {
      let params = {
        monthOrWeek: this.monthOrWeek
      };
      this.$post(queryStatistics, params).then(res => {
        if (res.success) {
          this.Statistics = res.data;
        } else {
          this.$message({
            message: res.msg,
            type: "error",
            duration: 1000
          });
        }
      });
    }
  }
};
</script>

<style lang="less">
.customStatistical {
  padding: 20px 0;
  .title {
    font-size: 16px;
    color: #333333;
    padding: 18px 0;
    border-bottom: 1px solid #e1e1e1;
    background: #ffffff;
    font-weight: bold;
  }
  .total {
    margin: 0 18px;
    padding: 0px 20px;
    background: #ffffff;
    .bottom_title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #e1e1e1;
      .title_text {
        padding: 18px 0;
        font-size: 16px;
        color: #333333;
        font-weight: bold;
      }
    }
    .report_form {
      // height: 477px;
      background: #ffffff;
      margin-top: 18px;
      padding: 0 20px;
      overflow: hidden;
      &_title {
        font-size: 16px;
        color: #333333;
        height: 52px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #e1e1e1;
        margin-bottom: 30px;
        > div {
          font-weight: bold;
          font-size: 16px;
        }
        &_tab {
          display: inline-block;
          width: 120px;
          height: 30px;
          text-align: center;
          line-height: 30px;
          border: 1px solid #c7d0ff;
          font-size: 18px;
          color: #666666;
          cursor: pointer;
          &_active {
            background: #5e75e6;
            color: #ffffff;
          }
        }
      }
    }
    .tab {
      display: flex;
      align-items: center;
      margin-bottom: 22px;
      &-item {
        width: 100px;
        height: 36px;
        font-size: 14px;
        line-height: 36px;
        background: #f1f1f1;
        text-align: center;
        cursor: pointer;
      }
      &-active {
        background: #ff9065;
        color: #ffffff;
      }
    }
    .list {
      display: flex;
      align-items: center;
      justify-content: space-between;
      &-item {
        flex: 1;
        text-align: center;
        border-left: 5px solid #ffffff;
        border-right: 5px solid #ffffff;

        &-title {
          font-size: 20px;
          color: #ffffff;
          padding-top: 40px;
          padding-bottom: 13px;
        }
        &-text {
          font-size: 16px;
          color: #ffffff;
        }
        &-content1 {
          margin: 0 auto;
          height: 130px;
          border-radius: 6px;
          background: url("../../assets/statisticalManage/ky-01.png") no-repeat;
          background-size: cover;
        }
        &-content2 {
          margin: 0 auto;
          height: 130px;
          border-radius: 6px;
          background: url("../../assets/statisticalManage/ky-02.png") no-repeat;
          background-size: cover;
        }
        &-content3 {
          margin: 0 auto;
          height: 130px;
          border-radius: 6px;
          background: url("../../assets/statisticalManage/ky-03.png") no-repeat;
          background-size: cover;
        }
        &-content4 {
          margin: 0 auto;
          height: 130px;
          border-radius: 6px;
          background: url("../../assets/statisticalManage/ky-04.png") no-repeat;
          background-size: cover;
        }
      }
    }
  }
  .total1 {
    margin: 18px 18px;
    display: flex;
    align-items: center;
    &-item:nth-child(1) {
      margin-right: 18px;
    }
    &-item {
      flex: 1;
      padding: 0 20px;
      background: #ffffff;
    }
  }
  .total2 {
    margin: 0 18px;
    padding: 0 20px 20px 20px;
    background: #ffffff;
    &-content {
      background: #f5f5f5;
      display: flex;
      align-items: center;
      margin-top: 30px;
      &-item:nth-child(1) {
        margin-right: 18px;
      }
      &-item {
        flex: 1;
        background: #ffffff;
        h3 {
          text-align: center;
          font-size: 16px;
          color: #333333;
          font-weight: bold;
        }
      }
    }
  }
  .total3 {
    margin: 20px 18px;
    padding: 0 20px 20px 20px;
    background: #ffffff;
    &-box {
      padding: 18px 0;
      border-bottom: 1px solid #e1e1e1;
      display: flex;
      justify-content: space-between;
      &-title {
        font-weight: bold;
      }
      &-item_time {
        display: flex;
        align-items: center;
        .el-select {
          .el-input {
            width: 100px;
            .el-input__inner {
              height: 30px;
              background: #f5f5f5;
              border: none;
            }
            .el-input__icon {
              line-height: 30px;
            }
          }
        }
        &_unit {
          padding: 0 10px;
        }
      }
    }
    &-content {
      background: #f5f5f5;
      display: flex;
      align-items: center;
      margin-top: 30px;
      &-item:nth-child(1) {
        margin-right: 18px;
      }
      &-item:nth-child(2) {
        margin-right: 18px;
      }
      &-item {
        flex: 1;
        background: #ffffff;
        h3 {
          text-align: center;
          font-size: 16px;
          color: #333333;
          font-weight: bold;
        }
      }
    }
  }
}
</style>